// extracted by mini-css-extract-plugin
export default {"legendContainer":"index_legendContainer__3+Ts3","title":"index_title__9qEYD","controls":"index_controls__Rcppy","svgWrap":"index_svgWrap__DZJfo"};